export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/realistic_pattern.88e7841.svg";